<ng-template>
    <app-change-password-modal [typeNumber]="'1'"></app-change-password-modal>
</ng-template>